import{m as e}from"./chunk-HBP5N4FR.js";e();var t=`.dapp-core-component__styles__results {
  display: flex;
  flex-direction: column;
  margin-top: 0.25rem;
}
.dapp-core-component__styles__results .dapp-core-component__styles__result {
  display: flex;
  border-left: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 1rem;
  margin-left: 1rem;
}
.dapp-core-component__styles__results .dapp-core-component__styles__result:not(:first-child) {
  padding-top: 1rem;
}
.dapp-core-component__styles__results .dapp-core-component__styles__result .dapp-core-component__styles__icon {
  margin-left: -1.1rem;
  margin-right: 0.5rem;
  border-radius: 50%;
  font-size: 0.9375rem;
  text-align: center;
  color: #6c757d;
  width: 2.1875rem;
  height: 2.1875rem;
  min-width: 2.1875rem;
  line-height: 2.1875rem;
  background: #fbfbfb;
  box-shadow: inset 0 0 3px rgba(108, 117, 125, 0.2);
}
.dapp-core-component__styles__results .dapp-core-component__styles__result .dapp-core-component__styles__content {
  flex: 1;
  margin-top: 0.4rem;
  max-width: calc(100% - 1.5875rem);
  width: calc(100% - 1.5875rem);
  display: block;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(t));var n={results:"dapp-core-component__styles__results",result:"dapp-core-component__styles__result",icon:"dapp-core-component__styles__icon",content:"dapp-core-component__styles__content"};export{t as a,n as b};
//# sourceMappingURL=chunk-NUHXMTKA.js.map
